import React from 'react';
import FsGridContainer from 'ui-elements/grid/FsGridContainer';
import FsGridItem from 'ui-elements/grid/FsGridItem';
import PersonalData from './PersonalData';
import Address from './Address';
import BankAccounts from './BankAccounts';
import BusinessData from './BusinessData';

const ReportPersonalAndBusinessData: React.FC = () => {
  return (
    <FsGridContainer>
      <FsGridItem xs={12} lg={4} isFlex>
        <PersonalData />
      </FsGridItem>
      <FsGridItem xs={12} lg={4} isFlex>
        <Address />
      </FsGridItem>
      <FsGridItem xs={12} lg={4} isFlex>
        <BankAccounts />
      </FsGridItem>
      <FsGridItem xs={12}>
        <BusinessData />
      </FsGridItem>
    </FsGridContainer>
  );
};

export default ReportPersonalAndBusinessData;
